import { render, staticRenderFns } from "./CardWeekly.vue?vue&type=template&id=06c28e00"
import script from "./CardWeekly.vue?vue&type=script&lang=js"
export * from "./CardWeekly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports